jQuery(function() {
  var formContainer = document.querySelector('.contact-container');

  if (formContainer && formContainer.dataset.redirect) {
    document.addEventListener(
      'wpcf7mailsent',
      function() {
        window.location = formContainer.dataset.redirect;
      },
      false
    );
  }

  // Hero Contact
  const heroContact = document.querySelector('.section-hero-contact');

  if (heroContact && heroContact.dataset.redirect) {
    document.addEventListener(
      'wpcf7mailsent',
      function() {
        window.location = heroContact.dataset.redirect;
      },
      false
    );
  }

  window.addUtmParamsToForm = function ($form) {
    if ($form) {
      $form.removeAttr('novalidate');

      var utmNames = [
        'utm_source',
        'utm_campaign',
        'utm_content',
        'utm_medium',
        'utm_expid',
        'utm_term',
      ];

      for (var i = 0; i < utmNames.length; i += 1) {
        var name = utmNames[i];
        var localValue = window.localStorage.getItem('binah_' + name);

        if (localValue) {
          jQuery('input[name=' + name + '__c' + ']', $form).val(localValue);
        }
      }
    }
  }
});



// WEBPACK FOOTER //
// ./scripts/blocks/contact.js